<script>
import Editor from "@tinymce/tinymce-vue";
import { OssUploaderForGtech } from "@root/lib/uploader";
import { gqlClient } from "@root/apollo/apollo-options";

// 多语言文档
// https://www.tiny.cloud/docs/configure/localization/#language

const langFormat = () => {
  const lang = (
    localStorage.getItem("Language") ||
    navigator.language ||
    navigator.browserLanguage
  ).toLowerCase();
  return /^zh*/.test(lang) ? "zh_CN" : "en_US";
};

export default {
  name: "GtEditor",

  functional: true,

  components: {
    Editor
  },

  render(h, context) {
    const { props, data } = context;
    const { options = {}, value, ...otherProps } = props;

    const DEFAULT_OPTIONS = {
      readonly: false,
      height: 560,
      body_class: "",
      menubar: "file edit insert view format table",
      object_resizing: false,
      toolbar: [
        "undo redo preview bold italic underline fontselect fontsizeselect forecolor backcolor",
        "lineheight bullist numlist alignleft aligncenter alignright outdent indent table emoticons link uploadImg media code fullscreen"
      ],
      plugins: [
        "lineheight advlist anchor autolink autosave code codesample directionality emoticons fullscreen preview hr image imagetools importcss link lists  nonbreaking noneditable pagebreak paste  print save searchreplace tabfocus table visualblocks visualchars wordcount"
      ],
      end_container_on_empty_block: true,
      powerpaste_word_import: "clean",
      code_dialog_height: 450,
      code_dialog_width: 1000,
      plugin_preview_height: 450,
      plugin_preview_width: 320,
      advlist_number_styles: "default",
      default_link_target: "_blank",
      link_title: false,
      nonbreaking_force_tab: true,
      branding: false,
      convert_fonts_to_spans: false,
      valid_elements: "*[*]",
      entity_encoding: "raw",
      relative_urls: false,
      convert_urls: false,
      schema: "html5",
      mode: "specific_textareas",
      forced_root_block: "",
      extended_valid_elements:
        "*[*],script[charset|defer|language|src|type],style",
      custom_elements: "*[*],script[charset|defer|language|src|type],style",
      valid_children: "+body[style],+body[script]",
      verify_html: false,
      media_strict: false,
      init_instance_callback: editor => {
        context.editor = editor;
      },

      setup(editor) {
        editor.on("FullscreenStateChanged", e => {
          context.$emit("fullscreen", e.state);
        });

        editor.ui.registry.addButton("imgupload", {
          strict: {
            title: "image",
            icon: "image",
            onclick: function () {
              editor.execCommand("mceImage");
            }
          }
        });
      },

      images_upload_handler: (blobInfo, success, failure) => {
        new OssUploaderForGtech({
          gqlClient,
          onfailure(err) {
            failure(err);
          },
          onsuccess(src) {
            success(src);
          }
        }).start(blobInfo.blob());
      }
    };

    return h(Editor, {
      ...data,

      props: {
        init: Object.assign({}, DEFAULT_OPTIONS, options, {
          language: langFormat()
        }),
        ...otherProps
      }
    });
  }
};
</script>
